<template>
  <div class="content">
    <div class="no-print">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'distributors_summary_report' }">
              {{ $t('router.distributorsSummaryReport') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ currentPageName }}</li>
        </ol>
      </nav>
      <detailed-report-period :initial-period="initialPeriod" hidden/>
    </div>

    <div class="col-md-8 ml-auto mr-auto">
      <h3 class="text-center">{{ $t('distributorReport.title') }}</h3>
      <p class="text-center mb-3 no-print">
        {{ $t('distributorReport.description') }}
      </p>
    </div>

    <div class="row justify-content-end pb-3 no-print">
      <base-button type="primary" @click="distributorOperationsRequested()" :loading="fileLoading"
                   :disabled="error !== null">
        <i class="tim-icons icon-cloud-download-93"></i>
        {{ $t('distributorReport.distributorOperationsBtnLbl') }}
      </base-button>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && !error && reportData" class="row ">
      <div class="col-6">
        <card :title="$t('distributorReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.generated_at | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.from | dateOnly }} - {{
                  reportData.to | dateOnly
                }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorReport.summary.distributorCompanyName') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.distributor_name }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorReport.summary.committedTransactionsCount') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.committed_transactions_count }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorReport.summary.totalCardsSold') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ totalCardsSold }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorReport.summary.totalCardsIssued') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ totalCardsIssued }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('distributorReport.summary.totalPosesAmount') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ totalPosesAmount | money }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="loading === false && !error && reportData" class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">
            {{ $t(`distributorReport.tableTitle`, {distributor_name: reportData.distributor_name}) }}
            <small v-if="reportData" class="ml-2 text-muted">({{ reportData.from | dateOnly }} - {{
                reportData.to | dateOnly
              }})</small>
          </h4>
          <el-table :data="reportData.data" :empty-text="$t('generic.emptyReportForThePeriod')"
                    show-summary :summary-method="getSoldSeasonTicketsTableTotal">
            <el-table-column :label="$t('distributorReport.table.operation_type')">
              <template slot-scope="{ row }">{{ row.operation_type }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('distributorReport.table.amount_sum')">
              <template slot-scope="{ row }">{{ row.amount_sum | money }}</template>
            </el-table-column>
            <el-table-column :label="$t('distributorReport.table.operations_count')">
              <template slot-scope="{ row }">{{ row.operations_count }}
              </template>
            </el-table-column>
          </el-table>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert} from 'src/components';
import {mapActions, mapState} from "vuex";
import ReportFilter from "./ReportFilter";
import DetailedReportPeriod from 'src/components/DetailedReportPeriod/DetailedReportPeriod';

export default {
  name: 'distributor-report',
  components: {
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ReportFilter,
    DetailedReportPeriod
  },
  data() {
    return {
      distributorId: null,
      period: null,
    };
  },
  computed: {
    ...mapState({
      fileLoading: state => state.distributor_report.fileLoading,
      loading: state => state.distributor_report.loading,
      error: state => state.distributor_report.error,
      reportData: state => state.distributor_report.reportData,
    }),
    currentPageName() {
      if (this.reportData) {
        return this.reportData.distributor_name
      }

      return this.$route.params.id
    },
    totalCardsSold() {
      if (!this.reportData || !this.reportData.data || this.reportData.data.length == 0) {
        return 0
      }

      let total = 0;
      this.reportData.data.forEach((e) => {
        switch (e.operation_type) {
          case 'card_sell':
            total = total + e.operations_count;
            break;
          case 'card_sell_with_top_up':
            total = total + e.operations_count;
            break;
        }
      });

      return total;
    },
    totalCardsIssued() {
      if (!this.reportData || !this.reportData.data || this.reportData.data.length == 0) {
        return 0
      }

      let total = 0;
      this.reportData.data.forEach((e) => {
        if (e.operation_type == 'card_issue') {
          total = total + e.operations_count
        }
      });

      return total;
    },
    totalPosesAmount() {
      if (!this.reportData || !this.reportData.data || this.reportData.data.length == 0) {
        return 0
      }

      let total = 0;
      this.reportData.data.forEach((e) => {
        total = total + e.amount_sum
      });

      return total;
    }
  },
  methods: {
    ...mapActions(['GetDistributorReport', 'GetDistributorOperationsReportFile']),
    initialPeriod(period) {
      this.period = period;
      this.GetDistributorReport({period: this.period, distributorId: this.$route.params.id})
    },
    distributorOperationsRequested() {
      this.GetDistributorOperationsReportFile({distributorId: this.distributorId, period: this.period})
    },
    getSoldSeasonTicketsTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('distributorReport.table.totalSum');
          return;
        }
        if (index === 1 || index === 2) {
          let values;
          if (index === 1) {
            values = data.map(item => Number(item.amount_sum));
          } else if (index === 2) {
            values = data.map(item => Number(item.operations_count));
          }

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }

          if (index === 1) {
            sums[index] = this.$options.filters['money'](sums[index])
          }

        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
  mounted() {
    this.distributorId = this.$route.params.id;
  }
};
</script>

